
import request from "@/utils/request"; // 引入request,基于axios
import queryString from "querystring"; // post方法传参转型String

export function getQuesion(data) {
  return request({
    url: `/enjoyment-server/app/assessment/` + data.id + `/question`,
    method: "get",
    data: data,
  });
}

export function submitAnswer(data,id) {
  return request({
    url: `/enjoyment-server/app/assessment/` + id + `/answer`,
    method: "post",
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
    data: JSON.stringify(data),
  });
}